<template>
  <div class="console">
    <h1 class="page-title">开发者控制台</h1>
    <p class="page-desc">查看配额与近 7 日调用趋势（演示数据，可替换为真实统计接口）。</p>

    <div class="stats grid-2">
      <div class="stat panel">
        <div class="stat__label">本月已用</div>
        <div class="stat__value mono">{{ usage.used.toLocaleString() }}</div>
        <div class="stat__sub">配额 {{ usage.quota.toLocaleString() }}</div>
        <div class="stat__bar">
          <i :style="{ width: pct + '%' }"></i>
        </div>
      </div>
      <div class="stat panel">
        <div class="stat__label">剩余额度</div>
        <div class="stat__value mono">{{ remaining.toLocaleString() }}</div>
        <div class="stat__sub">启用中密钥 {{ activeKeys }} 个</div>
        <div class="stat__links">
          <router-link to="/keys" class="btn btn-ghost">管理密钥</router-link>
          <router-link to="/usage" class="btn btn-primary">消耗明细</router-link>
        </div>
      </div>
    </div>

    <section class="panel chart">
      <div class="chart__head">
        <h2>近 7 日调用</h2>
        <span class="mono">errors 叠加显示</span>
      </div>
      <div class="chart__bars">
        <div v-for="d in usage.days" :key="d.date" class="bar">
          <div class="bar__track">
            <div class="bar__calls" :style="{ height: barH(d.calls) + '%' }" :title="d.calls + ' calls'"></div>
            <div class="bar__err" :style="{ height: Math.min(28, d.errors * 2) + '%' }" :title="d.errors + ' errors'"></div>
          </div>
          <div class="bar__label mono">{{ d.date.slice(5) }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getUsage, listKeys } from '../utils/apiStore'

export default {
  name: 'Console',
  data() {
    return {
      usage: getUsage(),
      keys: listKeys()
    }
  },
  computed: {
    remaining() {
      return Math.max(0, this.usage.quota - this.usage.used)
    },
    pct() {
      if (!this.usage.quota) return 0
      return Math.min(100, Math.round((this.usage.used / this.usage.quota) * 100))
    },
    activeKeys() {
      return this.keys.filter(k => k.enabled).length
    },
    maxCalls() {
      return Math.max(...this.usage.days.map(d => d.calls), 1)
    }
  },
  methods: {
    barH(calls) {
      return Math.round((calls / this.maxCalls) * 100)
    }
  }
}
</script>

<style scoped>
.stats {
  margin-bottom: 16px;
}
.stat {
  padding: 20px;
}
.stat__label {
  font-size: 12px;
  color: var(--muted);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.stat__value {
  margin-top: 8px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.03em;
}
.stat__sub {
  margin-top: 6px;
  font-size: 13px;
  color: var(--muted);
}
.stat__bar {
  margin-top: 16px;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  overflow: hidden;
}
.stat__bar i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #5eead4, #7dffb3);
}
.stat__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}
.chart {
  padding: 20px;
}
.chart__head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 18px;
}
.chart__head h2 {
  margin: 0;
  font-size: 16px;
}
.chart__head span {
  font-size: 11px;
  color: var(--muted);
}
.chart__bars {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  align-items: end;
  min-height: 180px;
}
.bar__track {
  position: relative;
  height: 140px;
  border-radius: 10px 10px 4px 4px;
  background: rgba(255, 255, 255, 0.03);
  overflow: hidden;
  display: flex;
  align-items: flex-end;
}
.bar__calls {
  width: 100%;
  background: linear-gradient(180deg, rgba(125, 255, 179, 0.85), rgba(94, 234, 212, 0.25));
  border-radius: 8px 8px 0 0;
}
.bar__err {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 107, 107, 0.55);
}
.bar__label {
  margin-top: 8px;
  text-align: center;
  font-size: 11px;
  color: var(--muted);
}
</style>
